import { Component, ViewChild } from '@angular/core';
import { Nav, MenuController, Platform, Events, AlertController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { Storage } from '@ionic/storage';
import { App } from 'ionic-angular';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  rootPage: any;
  user_id;
  user_type;
  type_user;

  pages: Array<{ title: string, component: any, icon: string }>;

  constructor(
    public platform: Platform,
    public storage: Storage,
    public statusBar: StatusBar,
    public events: Events,
    private menuCtrl: MenuController,
    public events2: Events,
    public alertCtrl: AlertController,
    public app: App,
    public splashScreen: SplashScreen) {
    events.subscribe('user:created', (user, time) => {
      this.type_user = user;
      if (this.type_user === '2') {
        this.pages = [
          { title: 'Home', component: 'HomePage', icon: 'ios-home-outline' },
          { title: 'Garage', component: 'VehiclePage', icon: 'ios-car-outline' },
          /* { title: 'Buscar', component: BusquedaPage, icon: 'ios-search-outline' },*/
          { title: 'Buscar', component: 'BusquedanewPage', icon: 'ios-search-outline' },
          { title: 'Solicitudes enviadas', component: 'SolicitudesPage', icon: 'ios-send-outline' },
          { title: 'Solicitudes recibidas', component: 'SolicitudesRecibidasPage', icon: 'ios-mail-outline' },
          { title: 'Artículos en venta', component: 'ProductsListPage', icon: 'ios-pricetags-outline' },
          { title: 'Perfil', component: 'ProfileUserPage', icon: 'ios-contact-outline' },
          { title: 'Ayuda & Soporte', component: 'HelpPage', icon: 'ios-help-buoy' },
          { title: 'Cerrar Sesión', component: 'LogoutPage', icon: 'ios-exit-outline' }
          

        ];
      } else {
        this.pages = [
          { title: 'Home', component: 'HomePage', icon: 'ios-home-outline' },
          { title: 'Garage', component: 'VehiclePage', icon: 'ios-car-outline' },
          /* { title: 'Buscar', component: 'BusquedaPage', icon: 'ios-search-outline' },*/
          { title: 'Buscar', component: 'BusquedanewPage', icon: 'ios-search-outline' },
          { title: 'Solicitudes Enviadas', component: 'SolicitudesPage', icon: 'ios-send-outline' },
          { title: 'Perfil', component: 'ProfileUserPage', icon: 'ios-contact-outline' },
          { title: 'Ayuda & Soporte', component: 'HelpPage', icon: 'ios-help-buoy' },
          { title: 'Cerrar Sesión', component: 'LogoutPage', icon: 'ios-exit-outline' }
        ];
      }
    });

    this.initializeApp();

    // used for an example of ngFor and navigation

  }

  initializeApp() {
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });

    this.platform.registerBackButtonAction(() => {
      const overlayView = this.app._appRoot._overlayPortal._views[0];
      if (overlayView && overlayView.dismiss) {
        overlayView.dismiss();
        return;
      }
      if (this.nav.canGoBack()) {
        this.nav.pop();
      }
      else {
        let view = this.nav.getActive();
        if (view.component == 'HomePage' || view.component == 'LoginPage') {
          const alert = this.alertCtrl.create({
            title: 'Salir de la aplicación',
            message: 'Esta seguro que desea salir?',
            buttons: [{
              text: 'Cancelar',
              role: 'cancel',
              handler: () => {
                //this.nav.setRoot('HomePage');
                this.rootPage = 'HomePage';
                console.log('** Salida de App Cancelada! **');
              }
            }, {
              text: 'Salir',
              handler: () => {
                //this.logout();
                this.platform.exitApp();
              }
            }]
          });
          alert.present();
        }
      }
    });
  }

  ngOnInit() {
    try {

      this.storage.get('user_id').then((user) => {
        this.user_id = user;
        if (this.user_id != null) {
          this.rootPage = 'HomePage';
        } else {
          this.rootPage = 'LoginPage';
        }
        this.capTypeUser();
      });
    } catch (error) {
      console.log("local storage esta vacio...o surgio algun error, vamos al login...");
      console.log(error);
      this.rootPage = 'LoginPage';

    }
  }

  capTypeUser() {
    this.storage.get('user_tipo').then((user_type) => {
      if (user_type === '2') {
        this.pages = [
          { title: 'Home', component: 'HomePage', icon: 'ios-home-outline' },
          { title: 'Garage', component: 'VehiclePage', icon: 'ios-car-outline' },
          { title: 'Buscar', component: 'BusquedanewPage', icon: 'ios-search-outline' },
          { title: 'Solicitudes enviadas', component: 'SolicitudesPage', icon: 'ios-send-outline' },
          { title: 'Solicitudes recibidas', component: 'SolicitudesRecibidasPage', icon: 'ios-mail-outline' },
          { title: 'Artículos en venta', component: 'ProductsListPage', icon: 'ios-pricetags-outline' },
          { title: 'Perfil', component: 'ProfileUserPage', icon: 'ios-contact-outline' },
          { title: 'Ayuda & Soporte', component: 'HelpPage', icon: 'ios-help-buoy' },
          { title: 'Cerrar Sesión', component: 'LogoutPage', icon: 'ios-exit-outline' }

        ];
      } else {
        this.pages = [
          { title: 'Home', component: 'HomePage', icon: 'ios-home-outline' },
          { title: 'Garage', component: 'VehiclePage', icon: 'ios-car-outline' },
          { title: 'Buscar', component: 'BusquedanewPage', icon: 'ios-search-outline' },
          { title: 'Solicitudes Enviadas', component: 'SolicitudesPage', icon: 'ios-send-outline' },
          { title: 'Perfil', component: 'ProfileUserPage', icon: 'ios-contact-outline' },
          { title: 'Ayuda & Soporte', component: 'HelpPage', icon: 'ios-help-buoy' },
          { title: 'Cerrar Sesión', component: 'LogoutPage', icon: 'ios-exit-outline' }
        ];
      }
    });
  }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    this.nav.setRoot(page.component, { pro: true });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts